import React from "react";
import { IconButton, useTheme } from "@mui/material";
import { CheckCircle, Close, Edit } from "@mui/icons-material";

interface ActivityActionButtonsProps {
  isDone: boolean;
  onComplete: () => void;
  onEdit: () => void;
  onDelete: () => void;
  stopPropagation?: boolean;
}

/**
 * Row actions for completing, editing and deleting an activity.
 */
const ActivityActionButtons = ({
  isDone,
  onComplete,
  onEdit,
  onDelete,
  stopPropagation = false,
}: ActivityActionButtonsProps) => {
  const theme = useTheme();
  // Currying lets us reuse the same click wrapper for multiple buttons while
  // still binding the specific action and centralizing optional stopPropagation.
  const handleClick = (action: () => void) => (event: React.MouseEvent<HTMLButtonElement>) => {
    if (stopPropagation) {
      event.stopPropagation();
    }
    action();
  };

  return (
    <>
      {!isDone && (
        <IconButton
          size="small"
          aria-label="Aktivität abschließen"
          onClick={handleClick(onComplete)}
          sx={{ color: theme.palette.success.main }}
        >
          <CheckCircle fontSize="small" />
        </IconButton>
      )}
      <IconButton
        size="small"
        aria-label="Aktivität bearbeiten"
        onClick={handleClick(onEdit)}
        sx={{ color: theme.palette.grey[600] }}
      >
        <Edit fontSize="small" />
      </IconButton>
      <IconButton
        size="small"
        aria-label="Aktivität löschen"
        onClick={handleClick(onDelete)}
        sx={{ color: theme.palette.error.main }}
      >
        <Close fontSize="small" />
      </IconButton>
    </>
  );
};

export default ActivityActionButtons;
